package com.rosario.juridico.ui.screens

import com.rosario.juridico.ui.components.WebScrollableContainer

import androidx.compose.animation.*
import androidx.compose.animation.core.*
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.ReceiptLong
import androidx.compose.material.icons.automirrored.filled.TrendingUp
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.navigation.NavController
import kotlinx.datetime.*
import com.rosario.juridico.domain.*
import com.rosario.juridico.navigation.Routes
import com.rosario.juridico.compartirTexto
import com.rosario.juridico.getPlatform
import com.rosario.juridico.ui.theme.Gold400
import com.rosario.juridico.ui.components.JuridicoDatePickerDialogKMP
import com.rosario.juridico.ui.components.JuridicoMonthYearPicker
import com.rosario.juridico.ui.components.CajaResultadoAccionable
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.window.Popup
import androidx.compose.ui.window.PopupProperties
import juridico5.composeapp.generated.resources.Res
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import com.rosario.juridico.premium.PremiumManager
import com.rosario.juridico.platform.BackendClient
import com.rosario.juridico.platform.IndiceCac

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun PantallaCalculadoraEconomica(navController: NavController) {
    val coroutineScope = rememberCoroutineScope()

    val hoy = Clock.System.todayIn(TimeZone.currentSystemDefault())
    val primerDiaMesActual = LocalDate(hoy.year, hoy.month, 1)

    val scrollState = rememberScrollState()
    val thousandSeparator = ThousandSeparatorVisualTransformation()

    // --- Estados Generales (Intereses) ---
    var interesesExpandido by remember { mutableStateOf(false) }
    var capital by remember { mutableStateOf("") }
    var fechaInicio by remember { mutableStateOf(LocalDate(hoy.year - 1, hoy.month, hoy.dayOfMonth)) }
    var fechaFin by remember { mutableStateOf(hoy) }
    var tipoTasaSeleccionado by remember { mutableStateOf(TipoTasa.BNA_ACTIVA) }
    var capitalizacionSeleccionada by remember { mutableStateOf(TipoCapitalizacion.SIMPLE) }
    var resultadoIntereses by remember { mutableStateOf<ResultadoLiquidacion?>(null) }
    var resultInteresesVisible by remember { mutableStateOf(false) }

    var expandedTasa by remember { mutableStateOf(false) }
    var expandedCap by remember { mutableStateOf(false) }
    var showInicioPicker by remember { mutableStateOf(false) }
    var showFinPicker by remember { mutableStateOf(false) }

    // --- Estados IPC ---
    var ipcExpandido by remember { mutableStateOf(false) }
    var ipcMonto by remember { mutableStateOf("") }
    var ipcFechaInicio by remember { mutableStateOf(LocalDate(hoy.year - 1, hoy.month, hoy.dayOfMonth)) }
    var ipcFechaFin by remember { mutableStateOf(hoy) }
    var resultadoIPC by remember { mutableStateOf<ResultadoIPC?>(null) }
    var resultIPCVisible by remember { mutableStateOf(false) }
    var cargandoIPC by remember { mutableStateOf(false) }
    var showIpcInicioPicker by remember { mutableStateOf(false) }
    var showIpcFinPicker by remember { mutableStateOf(false) }

    // --- Estados ICL ---
    var iclExpandido by remember { mutableStateOf(false) }
    var iclMonto by remember { mutableStateOf("") }
    var iclFechaInicio by remember { mutableStateOf(LocalDate(hoy.year - 1, hoy.month, hoy.dayOfMonth)) }
    var iclFechaFin by remember { mutableStateOf(hoy) }
    var resultadoICL by remember { mutableStateOf<ResultadoIPC?>(null) }
    var resultICLVisible by remember { mutableStateOf(false) }
    var cargandoICL by remember { mutableStateOf(false) }
    var showIclInicioPicker by remember { mutableStateOf(false) }
    var showIclFinPicker by remember { mutableStateOf(false) }

    // --- Estados Salarial ---
    var salarialExpandido by remember { mutableStateOf(false) }
    var salMonto by remember { mutableStateOf("") }
    var salFechaInicio by remember { mutableStateOf(LocalDate(hoy.year, 1, 1)) }
    var salFechaFin by remember { mutableStateOf(primerDiaMesActual) }
    var salConvenio by remember { mutableStateOf("IS_TOTAL") }
    var resultadoSalario by remember { mutableStateOf<ResultadoSalario?>(null) }
    var resultSalarioVisible by remember { mutableStateOf(false) }
    var expandedConvenio by remember { mutableStateOf(false) }
    var showSalInicioPicker by remember { mutableStateOf(false) }
    var showSalFinPicker by remember { mutableStateOf(false) }

    // --- Estados CAC ---
    var cacExpandido by remember { mutableStateOf(false) }
    var cacMonto by remember { mutableStateOf("") }
    var cacFechaInicio by remember { mutableStateOf(LocalDate(hoy.year, 1, 1)) }
    var cacFechaFin by remember { mutableStateOf(primerDiaMesActual) }
    var resultadoCAC by remember { mutableStateOf<ResultadoCAC?>(null) }
    var resultCACVisible by remember { mutableStateOf(false) }
    var cargandoCAC by remember { mutableStateOf(false) }
    var errorCAC by remember { mutableStateOf<String?>(null) }
    var ultimoIndiceCac by remember { mutableStateOf<IndiceCac?>(null) }
    var showCacInicioPicker by remember { mutableStateOf(false) }
    var showCacFinPicker by remember { mutableStateOf(false) }

    // --- Estados SMVM ---
    var smvmExpandido by remember { mutableStateOf(false) }
    var smvmPorcentaje by remember { mutableStateOf("20") }
    var smvmFechaInicio by remember { mutableStateOf(LocalDate(2024, 5, 1)) }
    var smvmFechaFin by remember { mutableStateOf(primerDiaMesActual) }
    var smvmPagos by remember { mutableStateOf(listOf<PagoParcial>()) }
    var smvmHonorariosPorc by remember { mutableStateOf("10") }
    var resultadoSMVM by remember { mutableStateOf<ResultadoCalculoSMVM?>(null) }
    var resultSMVMVisible by remember { mutableStateOf(false) }
    var cargandoSMVM by remember { mutableStateOf(false) }
    var showSmvmInicioPicker by remember { mutableStateOf(false) }
    var showSmvmFinPicker by remember { mutableStateOf(false) }
    var showAddPagoDialog by remember { mutableStateOf(false) }

    // --- Estados JUS Santa Fe ---
    var valorJusActualInformante by remember { mutableStateOf<Double?>(null) }
    LaunchedEffect(Unit) {
        try {
            val datos = obtenerDatosJus()
            if (datos.isNotEmpty()) valorJusActualInformante = datos.first().valor
        } catch (e: Exception) {}
    }
    var jusExpandido by remember { mutableStateOf(false) }
    var jusCantidad by remember { mutableStateOf("") }
    var jusModoPesos by remember { mutableStateOf(false) }
    var jusFechaOrigen by remember { mutableStateOf(hoy) }
    var resultadoJus by remember { mutableStateOf<ResultadoJus?>(null) }
    var resultJusVisible by remember { mutableStateOf(false) }
    var cargandoJus by remember { mutableStateOf(false) }
    var verificadoIA by remember { mutableStateOf(false) }
    var showJusFechaPicker by remember { mutableStateOf(false) }


    WebScrollableContainer(scrollState = scrollState, modifier = Modifier.fillMaxSize()) {
        Column(modifier = Modifier.fillMaxSize().imePadding().background(MaterialTheme.colorScheme.background).verticalScroll(scrollState)) {
        // HEADER
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .background(
                    brush = Brush.verticalGradient(
                        colors = listOf(Color(0xFF1A4B8C), Color(0xFF3B6DAE))
                    ),
                    shape = RoundedCornerShape(bottomStart = 32.dp, bottomEnd = 32.dp)
                )
                .padding(horizontal = 24.dp)
                .padding(top = 20.dp, bottom = 40.dp)
        ) {
            Column {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    IconButton(onClick = { navController.popBackStack() }) {
                        Icon(Icons.AutoMirrored.Filled.ArrowBack, contentDescription = "Volver", tint = Color.White)
                    }
                    Spacer(modifier = Modifier.width(8.dp))
                    Column {
                        Text("Calculadora Económica", color = Color.White, fontSize = 22.sp, fontWeight = FontWeight.ExtraBold)
                        Text("Liquidaciones e índices judiciales", color = Color.White.copy(alpha = 0.7f), fontSize = 12.sp)
                    }
                }
                
                Spacer(modifier = Modifier.height(16.dp))
                UsageCounterIndicator()
            }
        }

        Spacer(modifier = Modifier.height(16.dp))

        // SECCIÓN JUS SANTA FE (ART. 32 LEY 12851)
        SeccionExpandible(
            titulo = "Calculadora de MONTO ACTUALIZADO JUS ART. 32 Santa Fe",
            icono = Icons.Default.Gavel,
            color = Color(0xFF673AB7),
            expandido = jusExpandido,
            onExpandChange = { jusExpandido = it }
        ) {
            Text("Conversión de valor JUS histórico a precio de la actualidad", fontWeight = FontWeight.Bold, fontSize = 12.sp, color = Color.Gray)
            
            valorJusActualInformante?.let { valor ->
                Spacer(modifier = Modifier.height(12.dp))
                Surface(
                    color = Color(0xFF673AB7).copy(alpha = 0.08f),
                    shape = RoundedCornerShape(8.dp),
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Row(modifier = Modifier.padding(10.dp), verticalAlignment = Alignment.CenterVertically) {
                        Icon(Icons.Default.Info, null, tint = Color(0xFF673AB7), modifier = Modifier.size(18.dp))
                        Spacer(modifier = Modifier.width(8.dp))
                        Text("Valor JUS actual: ${valor.toPesos()}", fontSize = 13.sp, fontWeight = FontWeight.Bold, color = Color(0xFF673AB7))
                    }
                }
            }

            Spacer(modifier = Modifier.height(16.dp))
            
            Text("Expresar valor de origen en:", fontWeight = FontWeight.Bold, fontSize = 14.sp)
            Row(modifier = Modifier.fillMaxWidth().padding(vertical = 8.dp), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                FilterChip(
                    selected = !jusModoPesos,
                    onClick = { jusModoPesos = false; jusCantidad = "" },
                    label = { Text("Unidades JUS") },
                    leadingIcon = if (!jusModoPesos) { { Icon(Icons.Default.Check, null, modifier = Modifier.size(FilterChipDefaults.IconSize)) } } else null
                )
                FilterChip(
                    selected = jusModoPesos,
                    onClick = { jusModoPesos = true; jusCantidad = "" },
                    label = { Text("Monto en Pesos ($)") },
                    leadingIcon = if (jusModoPesos) { { Icon(Icons.Default.Check, null, modifier = Modifier.size(FilterChipDefaults.IconSize)) } } else null
                )
            }

            OutlinedTextField(
                value = jusCantidad,
                onValueChange = { input -> jusCantidad = if (jusModoPesos) input.filter { it.isDigit() } else input.filter { it.isDigit() || it == '.' } },
                label = { Text(if (jusModoPesos) "Monto histórico en Pesos" else "Cantidad de unidades JUS") },
                prefix = if (jusModoPesos) { { Text("$ ") } } else null,
                suffix = if (!jusModoPesos) { { Text("JUS") } } else null,
                visualTransformation = if (jusModoPesos) thousandSeparator else VisualTransformation.None,
                modifier = Modifier.fillMaxWidth().resaltadoGuia(jusCantidad.isEmpty()),
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                shape = RoundedCornerShape(12.dp)
            )

            Spacer(modifier = Modifier.height(16.dp))
            Text("Fecha de origen", fontWeight = FontWeight.Bold, fontSize = 14.sp)
            Box(modifier = Modifier.fillMaxWidth().clickable { showJusFechaPicker = true }) {
                OutlinedTextField(
                    value = jusFechaOrigen.toTexto(),
                    onValueChange = {},
                    readOnly = true,
                    modifier = Modifier.fillMaxWidth(),
                    enabled = false,
                    colors = OutlinedTextFieldDefaults.colors(
                        disabledTextColor = MaterialTheme.colorScheme.onSurface,
                        disabledBorderColor = MaterialTheme.colorScheme.outline,
                        disabledLabelColor = MaterialTheme.colorScheme.onSurfaceVariant,
                        disabledTrailingIconColor = MaterialTheme.colorScheme.onSurfaceVariant
                    ),
                    trailingIcon = { Icon(Icons.Default.CalendarToday, null) },
                    shape = RoundedCornerShape(12.dp)
                )
            }

            Spacer(modifier = Modifier.height(24.dp))
            CalculatorActionLock(
                navController = navController,
                onAction = {
                    cargandoJus = true; verificadoIA = false; resultJusVisible = false
                    coroutineScope.launch {
                        try {
                            val datos = obtenerDatosJus()
                            val valor = jusCantidad.toDoubleOrNull() ?: 0.0
                            delay(800) 
                            resultadoJus = if (jusModoPesos) calcularConversionDesdePesos(valor, jusFechaOrigen, datos) else calcularConversionJus(valor, jusFechaOrigen, datos)
                            delay(400)
                            resultJusVisible = true
                            // Tirón suave para asomar resultado y sugerir continuidad
                            scrollState.animateScrollTo(
                                value = scrollState.value + 300,
                                animationSpec = spring(stiffness = Spring.StiffnessLow)
                            )
                            verificadoIA = true
                        } catch (e: Exception) {
                            println("Error JUS: ${e.message}")
                        } finally {
                            cargandoJus = false
                        }
                    }
                }
            ) { onClick ->
                Button(
                    onClick = onClick,
                    modifier = Modifier.fillMaxWidth().height(56.dp),
                    enabled = !cargandoJus,
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF673AB7)),
                    shape = RoundedCornerShape(16.dp)
                ) {
                    if (cargandoJus) CircularProgressIndicator(modifier = Modifier.size(24.dp), color = Color.White)
                    else Text("Calcular Actualización JUS", color = Color.White, fontWeight = FontWeight.Bold)
                }
            }

            AnimatedVisibility(visible = resultJusVisible) {
                resultadoJus?.let { res ->
                    val textoCopia = """
                        ACTUALIZACIÓN JUS - ART. 32 LEY 12.851
                        Fecha de Origen: ${jusFechaOrigen.toTexto()}
                        Monto Origen: ${if (jusModoPesos) res.montoHistoricoPesos.toPesos() else "${res.cantidadJus.toFormato(2)} JUS"}
                        -------------------------------------------
                        VALOR ACTUALIZADO: ${res.montoActualizadoPesos.toPesos()}
                        Unidades: ${res.cantidadJus.toFormato(2)} JUS
                        -------------------------------------------
                        Calculado con www.juridicorosario.com
                    """.trimIndent()

                    CajaResultadoAccionable(
                        titulo = "Resultado de Actualización",
                        textoParaCompartir = textoCopia,
                        colorFondo = Color(0xFFEDE7F6)
                    ) {
                        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween) {
                            Column(modifier = Modifier.weight(1f)) {
                                Text("DESGLOSE HISTÓRICO", fontSize = 10.sp, fontWeight = FontWeight.Bold, color = Color.Gray)
                                Text("Monto: ${res.montoHistoricoPesos.toPesos()}", fontSize = 14.sp, fontWeight = FontWeight.Bold)
                                Text("Unidades: ${res.cantidadJus.toFormato(2)} JUS", fontSize = 13.sp, color = Color.Gray)
                            }
                            Column(modifier = Modifier.weight(1f), horizontalAlignment = Alignment.End) {
                                Text("VALOR ACTUALIZADO", fontSize = 10.sp, fontWeight = FontWeight.Bold, color = Color(0xFF673AB7))
                                Text("Monto: ${res.montoActualizadoPesos.toPesos()}", fontSize = 14.sp, fontWeight = FontWeight.Bold, color = Color(0xFF673AB7))
                                Text("Unidades: ${res.cantidadJus.toFormato(2)} JUS", fontSize = 13.sp, color = Color.Gray)
                            }
                        }

                        HorizontalDivider(modifier = Modifier.padding(vertical = 12.dp), thickness = 0.5.dp, color = Color.LightGray)

                        Text("RESULTADO FINAL INDEXADO", fontSize = 12.sp, fontWeight = FontWeight.Bold, color = Color.Gray)
                        Text(res.montoActualizadoPesos.toPesos(), fontSize = 30.sp, fontWeight = FontWeight.ExtraBold, color = Color(0xFF512DA8))
                    }
                }
            }
        }

        // SECCIÓN SMVM
        SeccionExpandible("Calculadora SMVM (Alimentos)", Icons.Default.FamilyRestroom, Color(0xFFE91E63), smvmExpandido, { smvmExpandido = it }) {
            Text("Cuota Alimentaria (% del SMVM)", fontWeight = FontWeight.Bold, fontSize = 14.sp)
            OutlinedTextField(value = smvmPorcentaje, onValueChange = { smvmPorcentaje = it.filter { c -> c.isDigit() || c == '.' } }, suffix = { Text("%") }, modifier = Modifier.fillMaxWidth().resaltadoGuia(smvmPorcentaje.isEmpty()), keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal), shape = RoundedCornerShape(12.dp))
            
            Spacer(modifier = Modifier.height(16.dp))
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Box(modifier = Modifier.weight(1f).clickable { showSmvmInicioPicker = true }) {
                    OutlinedTextField(
                        value = smvmFechaInicio.toMesAnio(),
                        onValueChange = {},
                        readOnly = true,
                        label = { Text("Desde") },
                        modifier = Modifier.fillMaxWidth(),
                        enabled = false,
                        colors = OutlinedTextFieldDefaults.colors(
                            disabledTextColor = MaterialTheme.colorScheme.onSurface,
                            disabledBorderColor = MaterialTheme.colorScheme.outline,
                            disabledLabelColor = MaterialTheme.colorScheme.onSurfaceVariant
                        ),
                        shape = RoundedCornerShape(12.dp)
                    )
                }
                Box(modifier = Modifier.weight(1f).clickable { showSmvmFinPicker = true }) {
                    OutlinedTextField(
                        value = smvmFechaFin.toMesAnio(),
                        onValueChange = {},
                        readOnly = true,
                        label = { Text("Hasta") },
                        modifier = Modifier.fillMaxWidth(),
                        enabled = false,
                        colors = OutlinedTextFieldDefaults.colors(
                            disabledTextColor = MaterialTheme.colorScheme.onSurface,
                            disabledBorderColor = MaterialTheme.colorScheme.outline,
                            disabledLabelColor = MaterialTheme.colorScheme.onSurfaceVariant
                        ),
                        shape = RoundedCornerShape(12.dp)
                    )
                }
            }

            Spacer(modifier = Modifier.height(24.dp))
            CalculatorActionLock(
                navController = navController,
                onAction = {
                    cargandoSMVM = true; resultSMVMVisible = false
                    coroutineScope.launch {
                        try {
                            val texto = SmvmLogic.leerSMVM()
                            val datos = SmvmLogic.parsearSMVM(texto)
                            resultadoSMVM = SmvmLogic.calcularLiquidacion(smvmPorcentaje.toDoubleOrNull() ?: 0.0, smvmFechaInicio, smvmFechaFin, smvmPagos, datos, smvmHonorariosPorc.toDoubleOrNull() ?: 0.0)
                            delay(400)
                            resultSMVMVisible = true
                            // Tirón suave
                            scrollState.animateScrollTo(
                                value = scrollState.value + 350,
                                animationSpec = spring(stiffness = Spring.StiffnessLow)
                            )
                        } catch (e: Exception) {
                            println("Error SMVM: ${e.message}")
                        } finally {
                            cargandoSMVM = false
                        }
                    }
                }
            ) { onClick ->
                Button(
                    onClick = onClick,
                    modifier = Modifier.fillMaxWidth().height(56.dp),
                    enabled = !cargandoSMVM,
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFE91E63)),
                    shape = RoundedCornerShape(16.dp)
                ) {
                    if (cargandoSMVM) CircularProgressIndicator(modifier = Modifier.size(24.dp), color = Color.White)
                    else Text("Calcular Liquidación SMVM", color = Color.White, fontWeight = FontWeight.Bold)
                }
            }

            AnimatedVisibility(visible = resultSMVMVisible) {
                resultadoSMVM?.let { res ->
                    val textoCopia = """
                        LIQUIDACIÓN CUOTA ALIMENTARIA - SMVM
                        Período: ${smvmFechaInicio.toMesAnio()} a ${smvmFechaFin.toMesAnio()}
                        Porcentaje Aplicado: $smvmPorcentaje%
                        -------------------------------------------
                        DEUDA TOTAL ACUMULADA: ${res.deudaTotal.toPesos()}
                        Honorarios Sugeridos: ${res.honorarios.toPesos()}
                        -------------------------------------------
                        Calculado con www.juridicorosario.com
                    """.trimIndent()

                    CajaResultadoAccionable(
                        titulo = "Resultado Liquidación",
                        textoParaCompartir = textoCopia,
                        colorFondo = Color(0xFFFCE4EC)
                    ) {
                        Column(modifier = Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
                            Text("Deuda Total Acumulada", fontSize = 14.sp, fontWeight = FontWeight.Bold)
                            Text(res.deudaTotal.toPesos(), fontSize = 28.sp, fontWeight = FontWeight.ExtraBold, color = Color(0xFFC2185B))
                        }
                    }
                }
            }
        }

        // SECCIÓN INTERESES
        SeccionExpandible("Calculadora de Intereses", Icons.Default.Calculate, Color(0xFF3B6DAE), interesesExpandido, { interesesExpandido = it }) {
            OutlinedTextField(value = capital, onValueChange = { capital = it.filter { c -> c.isDigit() } }, prefix = { Text("$ ") }, modifier = Modifier.fillMaxWidth().resaltadoGuia(capital.isEmpty()), visualTransformation = thousandSeparator, keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number), shape = RoundedCornerShape(12.dp))
            Spacer(modifier = Modifier.height(16.dp))
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                Box(modifier = Modifier.weight(1f).clickable { showInicioPicker = true }) {
                    OutlinedTextField(
                        value = fechaInicio.toTexto(),
                        onValueChange = {},
                        readOnly = true,
                        modifier = Modifier.fillMaxWidth(),
                        enabled = false,
                        colors = OutlinedTextFieldDefaults.colors(
                            disabledTextColor = MaterialTheme.colorScheme.onSurface,
                            disabledBorderColor = MaterialTheme.colorScheme.outline,
                            disabledLabelColor = MaterialTheme.colorScheme.onSurfaceVariant
                        ),
                        shape = RoundedCornerShape(12.dp)
                    )
                }
                Box(modifier = Modifier.weight(1f).clickable { showFinPicker = true }) {
                    OutlinedTextField(
                        value = fechaFin.toTexto(),
                        onValueChange = {},
                        readOnly = true,
                        modifier = Modifier.fillMaxWidth(),
                        enabled = false,
                        colors = OutlinedTextFieldDefaults.colors(
                            disabledTextColor = MaterialTheme.colorScheme.onSurface,
                            disabledBorderColor = MaterialTheme.colorScheme.outline,
                            disabledLabelColor = MaterialTheme.colorScheme.onSurfaceVariant
                        ),
                        shape = RoundedCornerShape(12.dp)
                    )
                }
            }
            Spacer(modifier = Modifier.height(24.dp))
            CalculatorActionLock(
                navController = navController,
                onAction = {
                    resultInteresesVisible = false
                    resultadoIntereses = calcularIntereses(capital.toDoubleOrNull() ?: 0.0, fechaInicio, fechaFin, tipoTasaSeleccionado, capitalizacionSeleccionada)
                    coroutineScope.launch {
                        delay(400)
                        resultInteresesVisible = true
                        // Tirón suave
                        scrollState.animateScrollTo(
                            value = scrollState.value + 300,
                            animationSpec = spring(stiffness = Spring.StiffnessLow)
                        )
                    }
                }
            ) { onClick ->
                Button(
                    onClick = onClick,
                    modifier = Modifier.fillMaxWidth().height(56.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFFFD700)),
                    shape = RoundedCornerShape(16.dp)
                ) { Text("Calcular Intereses", color = Color.Black, fontWeight = FontWeight.ExtraBold) }
            }

            AnimatedVisibility(visible = resultInteresesVisible) {
                resultadoIntereses?.let { res ->
                    val textoCopia = """
                        LIQUIDACIÓN DE INTERESES
                        Capital: $ ${res.capital.toFormato(2, true)}
                        Desde: ${fechaInicio.toTexto()}
                        Hasta: ${fechaFin.toTexto()}
                        Tasa Aplicada: ${tipoTasaSeleccionado.etiqueta}
                        Capitalización: ${capitalizacionSeleccionada.etiqueta}
                        -------------------------------------------
                        TOTAL INTERESES: $ ${res.interesTotal.toFormato(2, true)}
                        TOTAL ADEUDADO: ${res.totalAdeudado.toPesos()}
                        -------------------------------------------
                        Calculado con www.juridicorosario.com
                    """.trimIndent()

                    CajaResultadoAccionable(
                        titulo = "Resultado de Liquidación",
                        textoParaCompartir = textoCopia,
                        colorFondo = MaterialTheme.colorScheme.primaryContainer
                    ) {
                        Column(modifier = Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
                            Text("Total Adeudado", fontSize = 14.sp, fontWeight = FontWeight.Bold)
                            Text(res.totalAdeudado.toPesos(), fontSize = 28.sp, fontWeight = FontWeight.ExtraBold, color = MaterialTheme.colorScheme.primary)
                            Text("Intereses: $ ${res.interesTotal.toFormato(2, true)}", style = MaterialTheme.typography.bodySmall)
                        }
                    }
                }
            }
        }

        // SECCIÓN IPC
        SeccionExpandible("Calculadora de Inflación (IPC)", Icons.Default.Timeline, Color(0xFF4CAF50), ipcExpandido, { ipcExpandido = it }) {
            OutlinedTextField(value = ipcMonto, onValueChange = { ipcMonto = it.filter { c -> c.isDigit() } }, label = { Text("Monto a actualizar") }, prefix = { Text("$ ") }, modifier = Modifier.fillMaxWidth().resaltadoGuia(ipcMonto.isEmpty()), visualTransformation = thousandSeparator, keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number), shape = RoundedCornerShape(12.dp))
            Spacer(modifier = Modifier.height(16.dp))
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Box(modifier = Modifier.weight(1f).clickable { showIpcInicioPicker = true }) {
                    OutlinedTextField(
                        value = ipcFechaInicio.toTexto(),
                        onValueChange = {},
                        readOnly = true,
                        label = { Text("Fecha Inicio") },
                        modifier = Modifier.fillMaxWidth(),
                        enabled = false,
                        colors = OutlinedTextFieldDefaults.colors(
                            disabledTextColor = MaterialTheme.colorScheme.onSurface,
                            disabledBorderColor = MaterialTheme.colorScheme.outline,
                            disabledLabelColor = MaterialTheme.colorScheme.onSurfaceVariant
                        ),
                        shape = RoundedCornerShape(12.dp)
                    )
                }
                Box(modifier = Modifier.weight(1f).clickable { showIpcFinPicker = true }) {
                    OutlinedTextField(
                        value = ipcFechaFin.toTexto(),
                        onValueChange = {},
                        readOnly = true,
                        label = { Text("Fecha Fin") },
                        modifier = Modifier.fillMaxWidth(),
                        enabled = false,
                        colors = OutlinedTextFieldDefaults.colors(
                            disabledTextColor = MaterialTheme.colorScheme.onSurface,
                            disabledBorderColor = MaterialTheme.colorScheme.outline,
                            disabledLabelColor = MaterialTheme.colorScheme.onSurfaceVariant
                        ),
                        shape = RoundedCornerShape(12.dp)
                    )
                }
            }
            Spacer(modifier = Modifier.height(24.dp))
            CalculatorActionLock(
                navController = navController,
                onAction = {
                    cargandoIPC = true; resultIPCVisible = false
                    coroutineScope.launch {
                        try {
                            val ipcBase = BackendClient.fetchIPCData()
                            resultadoIPC = calcularIPCPericial(ipcMonto.toDoubleOrNull() ?: 0.0, ipcFechaInicio, ipcFechaFin, ipcBase)
                            delay(400)
                            resultIPCVisible = true
                            // Tirón suave
                            scrollState.animateScrollTo(
                                value = scrollState.value + 300,
                                animationSpec = spring(stiffness = Spring.StiffnessLow)
                            )
                        } catch (e: Exception) {
                            println("UI IPC Error: ${e.message}")
                            e.printStackTrace()
                        } finally {
                            cargandoIPC = false
                        }
                    }
                }
            ) { onClick ->
                Button(
                    onClick = onClick,
                    modifier = Modifier.fillMaxWidth().height(56.dp),
                    enabled = !cargandoIPC,
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF4CAF50)),
                    shape = RoundedCornerShape(16.dp)
                ) {
                    if (cargandoIPC) CircularProgressIndicator(modifier = Modifier.size(24.dp), color = Color.White)
                    else Text("Calcular Actualización IPC", color = Color.White, fontWeight = FontWeight.Bold)
                }
            }

            AnimatedVisibility(visible = resultIPCVisible) {
                resultadoIPC?.let { res ->
                    val avisoLegal = if (res.esProyectado) {
                        "\n⚠️ AVISO: Valor aproximado por falta de publicación oficial al ${ipcFechaFin.toTexto()}. Sujeto a ajuste posterior."
                    } else if (res.mesSolicitado != res.mesRealUtilizado) {
                        "\n⚠️ AVISO: Índice ${formatYearMonthSpanish(res.mesSolicitado)} no publicado. Se usó el de ${formatYearMonthSpanish(res.mesRealUtilizado)}."
                    } else ""

                    val textoCopia = """
                        ACTUALIZACIÓN POR INFLACIÓN (IPC)
                        Monto Original: ${res.montoInicial.toPesos()} (${ipcFechaInicio.toTextoSpanish()})
                        Monto Actualizado: ${res.montoActualizado.toPesos()} (${ipcFechaFin.toTextoSpanish()})$avisoLegal
                        Variación: ${res.variacionPorcentual.toPorcentajeDirecto()}
                        -------------------------------------------
                        Calculado con www.juridicorosario.com
                    """.trimIndent()

                    Column(modifier = Modifier.padding(top = 16.dp)) {
                        CajaResultadoAccionable(
                            titulo = "Resultado Actualización IPC",
                            textoParaCompartir = textoCopia,
                            colorFondo = Color(0xFFF1F8E9)
                        ) {
                            Column {
                                Text(
                                    text = "${res.montoInicial.toPesos()} en ${ipcFechaInicio.toTextoSpanish()}",
                                    style = MaterialTheme.typography.bodyLarge,
                                    color = Color.DarkGray
                                )
                                Text(
                                    text = "equivale aproximadamente a",
                                    style = MaterialTheme.typography.bodySmall,
                                    color = Color.Gray,
                                    modifier = Modifier.padding(vertical = 4.dp)
                                )
                                Text(
                                    text = "${res.montoActualizado.toPesos()} en ${ipcFechaFin.toTextoSpanish()}",
                                    style = MaterialTheme.typography.headlineSmall,
                                    fontWeight = FontWeight.ExtraBold,
                                    color = Color(0xFF2E7D32)
                                )

                                Spacer(modifier = Modifier.height(16.dp))
                                HorizontalDivider(thickness = 0.5.dp, color = Color.LightGray)
                                Spacer(modifier = Modifier.height(12.dp))

                                Text(
                                    text = "Fuente: Índice de precios al consumidor (INDEC)",
                                    style = MaterialTheme.typography.labelSmall,
                                    color = Color.Gray
                                )

                                AvisoProyeccionIPC(ipcFechaFin, res.esProyectado)
                                AvisoIndiceNoPublicado(res.mesSolicitado, res.mesRealUtilizado)

                                Spacer(modifier = Modifier.height(12.dp))
                                Surface(
                                    color = Color(0xFFC8E6C9),
                                    shape = RoundedCornerShape(8.dp)
                                ) {
                                    Text(
                                        text = "Esto representa un incremento del ${res.variacionPorcentual.toPorcentajeDirecto()}",
                                        modifier = Modifier.padding(horizontal = 10.dp, vertical = 6.dp),
                                        style = MaterialTheme.typography.labelMedium,
                                        fontWeight = FontWeight.Bold,
                                        color = Color(0xFF1B5E20)
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }

        // SECCIÓN ICL
        SeccionExpandible("Calculadora ICL (Alquileres)", Icons.Default.Home, Color(0xFFE91E63), iclExpandido, { iclExpandido = it }) {
            OutlinedTextField(value = iclMonto, onValueChange = { iclMonto = it.filter { c -> c.isDigit() } }, label = { Text("Monto de alquiler a actualizar") }, prefix = { Text("$ ") }, modifier = Modifier.fillMaxWidth().resaltadoGuia(iclMonto.isEmpty()), visualTransformation = thousandSeparator, keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number), shape = RoundedCornerShape(12.dp))
            Spacer(modifier = Modifier.height(16.dp))
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Box(modifier = Modifier.weight(1f).clickable { showIclInicioPicker = true }) {
                    OutlinedTextField(
                        value = iclFechaInicio.toTexto(),
                        onValueChange = {},
                        readOnly = true,
                        label = { Text("Fecha Inicio") },
                        modifier = Modifier.fillMaxWidth(),
                        enabled = false,
                        colors = OutlinedTextFieldDefaults.colors(
                            disabledTextColor = MaterialTheme.colorScheme.onSurface,
                            disabledBorderColor = MaterialTheme.colorScheme.outline,
                            disabledLabelColor = MaterialTheme.colorScheme.onSurfaceVariant
                        ),
                        shape = RoundedCornerShape(12.dp)
                    )
                }
                Box(modifier = Modifier.weight(1f).clickable { showIclFinPicker = true }) {
                    OutlinedTextField(
                        value = iclFechaFin.toTexto(),
                        onValueChange = {},
                        readOnly = true,
                        label = { Text("Fecha Fin") },
                        modifier = Modifier.fillMaxWidth(),
                        enabled = false,
                        colors = OutlinedTextFieldDefaults.colors(
                            disabledTextColor = MaterialTheme.colorScheme.onSurface,
                            disabledBorderColor = MaterialTheme.colorScheme.outline,
                            disabledLabelColor = MaterialTheme.colorScheme.onSurfaceVariant
                        ),
                        shape = RoundedCornerShape(12.dp)
                    )
                }
            }
            Spacer(modifier = Modifier.height(24.dp))
            CalculatorActionLock(
                navController = navController,
                onAction = {
                    cargandoICL = true; resultICLVisible = false
                    coroutineScope.launch {
                        try {
                            val iclBase = BackendClient.fetchICLData()
                            resultadoICL = calcularICLDiario(iclMonto.toDoubleOrNull() ?: 0.0, iclFechaInicio, iclFechaFin, iclBase)
                            delay(400)
                            resultICLVisible = true
                            // Tirón suave
                            scrollState.animateScrollTo(
                                value = scrollState.value + 300,
                                animationSpec = spring(stiffness = Spring.StiffnessLow)
                            )
                        } catch (e: Exception) {
                            println("UI ICL Error: ${e.message}")
                            e.printStackTrace()
                        } finally {
                            cargandoICL = false
                        }
                    }
                }
            ) { onClick ->
                Button(
                    onClick = onClick,
                    modifier = Modifier.fillMaxWidth().height(56.dp),
                    enabled = !cargandoICL,
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFE91E63)),
                    shape = RoundedCornerShape(16.dp)
                ) {
                    if (cargandoICL) CircularProgressIndicator(modifier = Modifier.size(24.dp), color = Color.White)
                    else Text("Calcular Actualización ICL", color = Color.White, fontWeight = FontWeight.Bold)
                }
            }

            AnimatedVisibility(visible = resultICLVisible) {
                resultadoICL?.let { res ->
                    val textoCopia = """
                        ACTUALIZACIÓN ALQUILER (ICL)
                        Monto Original: ${res.montoInicial.toPesos()} (${iclFechaInicio.toTextoSpanish()})
                        Monto Actualizado: ${res.montoActualizado.toPesos()} (${iclFechaFin.toTextoSpanish()})
                        Variación: ${res.variacionPorcentual.toPorcentajeDirecto()}
                        -------------------------------------------
                        Calculado con www.juridicorosario.com
                    """.trimIndent()

                    Column(modifier = Modifier.padding(top = 16.dp)) {
                        CajaResultadoAccionable(
                            titulo = "Resultado Actualización ICL",
                            textoParaCompartir = textoCopia,
                            colorFondo = Color(0xFFFCE4EC)
                        ) {
                            Column {
                                Text(
                                    text = "${res.montoInicial.toPesos()} en ${iclFechaInicio.toTextoSpanish()}",
                                    style = MaterialTheme.typography.bodyLarge,
                                    color = Color.DarkGray
                                )
                                Text(
                                    text = "equivale aproximadamente a",
                                    style = MaterialTheme.typography.bodySmall,
                                    color = Color.Gray,
                                    modifier = Modifier.padding(vertical = 4.dp)
                                )
                                Text(
                                    text = "${res.montoActualizado.toPesos()} en ${iclFechaFin.toTextoSpanish()}",
                                    style = MaterialTheme.typography.headlineSmall,
                                    fontWeight = FontWeight.ExtraBold,
                                    color = Color(0xFFC2185B)
                                )

                                Spacer(modifier = Modifier.height(16.dp))
                                HorizontalDivider(thickness = 0.5.dp, color = Color.LightGray)
                                Spacer(modifier = Modifier.height(12.dp))

                                Text(
                                    text = "Fuente: Índice para Contratos de Locación (BCRA)",
                                    style = MaterialTheme.typography.labelSmall,
                                    color = Color.Gray
                                )

                                if (res.esProyectado) {
                                    Row(
                                        modifier = Modifier.padding(top = 4.dp),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Icon(
                                            Icons.Default.Warning,
                                            null,
                                            tint = Color(0xFFE65100),
                                            modifier = Modifier.size(12.dp)
                                        )
                                        Spacer(modifier = Modifier.width(4.dp))
                                        Text(
                                            text = "Calculado utilizando el último ICL diario publicado correspondiente al ${formatIclDateSpanish(res.mesUsadoComoProyeccion)}.",
                                            fontSize = 10.sp,
                                            color = Color(0xFFE65100),
                                            lineHeight = 12.sp
                                        )
                                    }
                                }

                                Spacer(modifier = Modifier.height(12.dp))
                                Surface(
                                    color = Color(0xFFF8BBD0),
                                    shape = RoundedCornerShape(8.dp)
                                ) {
                                    Text(
                                        text = "Esto representa un incremento del ${res.variacionPorcentual.toPorcentajeDirecto()}",
                                        modifier = Modifier.padding(horizontal = 10.dp, vertical = 6.dp),
                                        style = MaterialTheme.typography.labelMedium,
                                        fontWeight = FontWeight.Bold,
                                        color = Color(0xFF880E4F)
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }

        // SECCIÓN SALARIO
        SeccionExpandible("Calculadora Salario", Icons.Default.Work, Color(0xFF009688), salarialExpandido, { salarialExpandido = it }) {
            OutlinedTextField(
                value = salMonto,
                onValueChange = { salMonto = it.filter { c -> c.isDigit() } },
                label = { Text("Monto a actualizar") },
                prefix = { Text("$ ") },
                modifier = Modifier.fillMaxWidth().resaltadoGuia(salMonto.isEmpty()),
                visualTransformation = thousandSeparator,
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                shape = RoundedCornerShape(12.dp)
            )
            Spacer(modifier = Modifier.height(16.dp))

            Text("Convenio / Sector", fontWeight = FontWeight.Bold, fontSize = 14.sp)
            ExposedDropdownMenuBox(
                expanded = expandedConvenio,
                onExpandedChange = { expandedConvenio = it }
            ) {
                OutlinedTextField(
                    value = DatosSalario.etiqueta(salConvenio),
                    onValueChange = {},
                    readOnly = true,
                    trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expandedConvenio) },
                    modifier = Modifier.fillMaxWidth().menuAnchor(MenuAnchorType.PrimaryNotEditable),
                    shape = RoundedCornerShape(12.dp)
                )
                ExposedDropdownMenu(
                    expanded = expandedConvenio,
                    onDismissRequest = { expandedConvenio = false }
                ) {
                    DatosSalario.convenios.forEach { (id, label) ->
                        DropdownMenuItem(
                            text = { Text(label) },
                            onClick = {
                                salConvenio = id
                                expandedConvenio = false
                            }
                        )
                    }
                }
            }

            Spacer(modifier = Modifier.height(16.dp))
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Box(modifier = Modifier.weight(1f).clickable { showSalInicioPicker = true }) {
                    OutlinedTextField(
                        value = salFechaInicio.toMesAnio(),
                        onValueChange = {},
                        readOnly = true,
                        label = { Text("Mes Base") },
                        modifier = Modifier.fillMaxWidth(),
                        enabled = false,
                        colors = OutlinedTextFieldDefaults.colors(
                            disabledTextColor = MaterialTheme.colorScheme.onSurface,
                            disabledBorderColor = MaterialTheme.colorScheme.outline,
                            disabledLabelColor = MaterialTheme.colorScheme.onSurfaceVariant
                        ),
                        shape = RoundedCornerShape(12.dp)
                    )
                }
                Box(modifier = Modifier.weight(1f).clickable { showSalFinPicker = true }) {
                    OutlinedTextField(
                        value = salFechaFin.toMesAnio(),
                        onValueChange = {},
                        readOnly = true,
                        label = { Text("Mes Destino") },
                        modifier = Modifier.fillMaxWidth(),
                        enabled = false,
                        colors = OutlinedTextFieldDefaults.colors(
                            disabledTextColor = MaterialTheme.colorScheme.onSurface,
                            disabledBorderColor = MaterialTheme.colorScheme.outline,
                            disabledLabelColor = MaterialTheme.colorScheme.onSurfaceVariant
                        ),
                        shape = RoundedCornerShape(12.dp)
                    )
                }
            }

            Spacer(modifier = Modifier.height(24.dp))
            CalculatorActionLock(
                navController = navController,
                onAction = {
                    resultSalarioVisible = false
                    resultadoSalario = calcularSalario(salMonto.toDoubleOrNull() ?: 0.0, salFechaInicio, salFechaFin, salConvenio)
                    coroutineScope.launch {
                        delay(400)
                        resultSalarioVisible = true
                        // Tirón suave
                        scrollState.animateScrollTo(
                            value = scrollState.value + 300,
                            animationSpec = spring(stiffness = Spring.StiffnessLow)
                        )
                    }
                }
            ) { onClick ->
                Button(
                    onClick = onClick,
                    modifier = Modifier.fillMaxWidth().height(56.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF009688)),
                    shape = RoundedCornerShape(16.dp)
                ) {
                    Text("Calcular Actualización Salarial", color = Color.White, fontWeight = FontWeight.Bold)
                }
            }

            AnimatedVisibility(visible = resultSalarioVisible) {
                resultadoSalario?.let { res ->
                    val textoCopia = """
                        ACTUALIZACIÓN SALARIAL
                        Sector/Convenio: ${DatosSalario.etiqueta(salConvenio)}
                        Monto Original: ${salMonto.toDoubleOrNull()?.toPesos() ?: ""} (${salFechaInicio.toMesAnio()})
                        Monto Actualizado: ${res.montoActualizado.toPesos()} (${salFechaFin.toMesAnio()})
                        Variación: ${res.variacionPorcentual.toPorcentajeDirecto()}
                        -------------------------------------------
                        Calculado con www.juridicorosario.com
                    """.trimIndent()

                    CajaResultadoAccionable(
                        titulo = "Resultado Actualización Salarial",
                        textoParaCompartir = textoCopia,
                        colorFondo = Color(0xFFE0F2F1)
                    ) {
                        Column {
                            Text("Monto Actualizado", fontSize = 14.sp, fontWeight = FontWeight.Bold)
                            Text(res.montoActualizado.toPesos(), fontSize = 28.sp, fontWeight = FontWeight.ExtraBold, color = Color(0xFF00796B))
                            Text("Variación: ${res.variacionPorcentual.toPorcentajeDirecto()}", fontSize = 14.sp, color = Color.Gray)
                        }
                    }
                }
            }
        }

        // SECCIÓN CAC
        SeccionExpandible("Calculadora CAC (Construcción)", Icons.Default.Business, Color(0xFFFF5722), cacExpandido, { cacExpandido = it }) {
            OutlinedTextField(
                value = cacMonto,
                onValueChange = { cacMonto = it.filter { c -> c.isDigit() } },
                label = { Text("Monto de obra a actualizar") },
                prefix = { Text("$ ") },
                modifier = Modifier.fillMaxWidth().resaltadoGuia(cacMonto.isEmpty()),
                visualTransformation = thousandSeparator,
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                shape = RoundedCornerShape(12.dp)
            )
            Spacer(modifier = Modifier.height(16.dp))
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Box(modifier = Modifier.weight(1f).clickable { showCacInicioPicker = true }) {
                    OutlinedTextField(
                        value = cacFechaInicio.toMesAnio(),
                        onValueChange = {},
                        readOnly = true,
                        label = { Text("Mes Base") },
                        modifier = Modifier.fillMaxWidth(),
                        enabled = false,
                        colors = OutlinedTextFieldDefaults.colors(
                            disabledTextColor = MaterialTheme.colorScheme.onSurface,
                            disabledBorderColor = MaterialTheme.colorScheme.outline,
                            disabledLabelColor = MaterialTheme.colorScheme.onSurfaceVariant
                        ),
                        shape = RoundedCornerShape(12.dp)
                    )
                }
                Box(modifier = Modifier.weight(1f).clickable { showCacFinPicker = true }) {
                    OutlinedTextField(
                        value = cacFechaFin.toMesAnio(),
                        onValueChange = {},
                        readOnly = true,
                        label = { Text("Mes Destino") },
                        modifier = Modifier.fillMaxWidth(),
                        enabled = false,
                        colors = OutlinedTextFieldDefaults.colors(
                            disabledTextColor = MaterialTheme.colorScheme.onSurface,
                            disabledBorderColor = MaterialTheme.colorScheme.outline,
                            disabledLabelColor = MaterialTheme.colorScheme.onSurfaceVariant
                        ),
                        shape = RoundedCornerShape(12.dp)
                    )
                }
            }

            Spacer(modifier = Modifier.height(24.dp))
            CalculatorActionLock(
                navController = navController,
                onAction = {
                    cargandoCAC = true; resultCACVisible = false; errorCAC = null
                    coroutineScope.launch {
                        try {
                            val datos = BackendClient.fetchCACData()
                            ultimoIndiceCac = datos.lastOrNull()
                            resultadoCAC = calcularCAC(cacMonto.toDoubleOrNull() ?: 0.0, cacFechaInicio.toYearMonth(), cacFechaFin.toYearMonth(), datos)
                            delay(400)
                            resultCACVisible = true
                            // Tirón suave
                            scrollState.animateScrollTo(
                                value = scrollState.value + 350,
                                animationSpec = spring(stiffness = Spring.StiffnessLow)
                            )
                        } catch (e: Exception) {
                            errorCAC = e.message
                        } finally {
                            cargandoCAC = false
                        }
                    }
                }
            ) { onClick ->
                Button(
                    onClick = onClick,
                    modifier = Modifier.fillMaxWidth().height(56.dp),
                    enabled = !cargandoCAC,
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFFF5722)),
                    shape = RoundedCornerShape(16.dp)
                ) {
                    if (cargandoCAC) CircularProgressIndicator(modifier = Modifier.size(24.dp), color = Color.White)
                    else Text("Calcular Actualización CAC", color = Color.White, fontWeight = FontWeight.Bold)
                }
            }

            if (errorCAC != null) {
                Text(errorCAC!!, color = Color.Red, fontSize = 12.sp, modifier = Modifier.padding(top = 8.dp))
            }

            AnimatedVisibility(visible = resultCACVisible) {
                resultadoCAC?.let { res ->
                    val avisoTexto = if (res.mesSolicitado != res.mesRealUtilizado) {
                        "\n⚠️ AVISO: Índice ${formatYearMonthSpanish(res.mesSolicitado)} no publicado. Se usó el de ${formatYearMonthSpanish(res.mesRealUtilizado)}."
                    } else ""

                    val textoCopia = """
                        ACTUALIZACIÓN COSTO CONSTRUCCIÓN (CAC)
                        Monto Original: ${cacMonto.toDoubleOrNull()?.toPesos() ?: ""} (${cacFechaInicio.toMesAnio()})$avisoTexto
                        -------------------------------------------
                        ÍNDICE GENERAL: ${res.general.montoActualizado.toPesos()} (+${res.general.variacionPorcentual.toPorcentajeDirecto()})
                        ÍNDICE MATERIALES: ${res.materiales.montoActualizado.toPesos()} (+${res.materiales.variacionPorcentual.toPorcentajeDirecto()})
                        ÍNDICE MANO DE OBRA: ${res.manoObra.montoActualizado.toPesos()} (+${res.manoObra.variacionPorcentual.toPorcentajeDirecto()})
                        -------------------------------------------
                        Calculado con www.juridicorosario.com
                    """.trimIndent()

                    CajaResultadoAccionable(
                        titulo = "Resultado Actualización CAC",
                        textoParaCompartir = textoCopia,
                        colorFondo = Color.Transparent
                    ) {
                        Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                            ultimoIndiceCac?.let { ultimo ->
                                Surface(
                                    modifier = Modifier.fillMaxWidth().padding(bottom = 4.dp),
                                    color = MaterialTheme.colorScheme.surfaceVariant,
                                    shape = MaterialTheme.shapes.small
                                ) {
                                    Row(
                                        modifier = Modifier.padding(12.dp),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Icon(
                                            imageVector = Icons.Default.Info,
                                            contentDescription = "Info",
                                            tint = MaterialTheme.colorScheme.primary,
                                            modifier = Modifier.size(20.dp)
                                        )
                                        Spacer(modifier = Modifier.width(8.dp))
                                        Text(
                                            text = "Último índice publicado (${ultimo.fecha}): General ${ultimo.general}",
                                            style = MaterialTheme.typography.bodySmall,
                                            color = MaterialTheme.colorScheme.onSurfaceVariant
                                        )
                                    }
                                }
                            }

                            CardCAC(res.general, "ÍNDICE GENERAL (Costo de vida)")
                            CardCAC(res.materiales, "ÍNDICE MATERIALES")
                            CardCAC(res.manoObra, "ÍNDICE MANO DE OBRA")

                            AvisoIndiceNoPublicado(res.mesSolicitado, res.mesRealUtilizado)

                            if (res.mesPendiente != null && res.mesSolicitado == res.mesRealUtilizado) {
                                Card(colors = CardDefaults.cardColors(containerColor = Color(0xFFFFF3E0)), modifier = Modifier.fillMaxWidth()) {
                                    Row(modifier = Modifier.padding(12.dp), verticalAlignment = Alignment.CenterVertically) {
                                        Icon(Icons.Default.Info, null, tint = Color(0xFFE65100))
                                        Spacer(modifier = Modifier.width(8.dp))
                                        Text("El mes ${res.mesPendiente} aún no ha sido publicado oficialmente. Se utiliza una estimación. Próxima publicación: ${res.fechaProximaPublicacion}", fontSize = 11.sp, color = Color(0xFFE65100))
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        Spacer(modifier = Modifier.height(12.dp))
        Card(modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp).height(80.dp).clickable { navController.navigate("liquidador_deuda") }, colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant)) {
            Box(contentAlignment = Alignment.Center, modifier = Modifier.fillMaxSize()) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.AutoMirrored.Filled.ReceiptLong, null, tint = MaterialTheme.colorScheme.primary)
                    Spacer(modifier = Modifier.width(12.dp))
                    Text("Ir al Liquidador de Deuda Completo", fontWeight = FontWeight.Bold)
                }
            }
        }
        Spacer(modifier = Modifier.height(40.dp))
    }
}

    // PICKERS
    if (showInicioPicker) JuridicoDatePickerDialogKMP(onDateSelected = { fechaInicio = it; showInicioPicker = false }, onDismiss = { showInicioPicker = false })
    if (showFinPicker) JuridicoDatePickerDialogKMP(onDateSelected = { fechaFin = it; showFinPicker = false }, onDismiss = { showFinPicker = false })
    if (showIpcInicioPicker) JuridicoDatePickerDialogKMP(onDateSelected = { ipcFechaInicio = it; showIpcInicioPicker = false }, onDismiss = { showIpcInicioPicker = false })
    if (showIpcFinPicker) JuridicoDatePickerDialogKMP(onDateSelected = { ipcFechaFin = it; showIpcFinPicker = false }, onDismiss = { showIpcFinPicker = false })
    if (showIclInicioPicker) JuridicoDatePickerDialogKMP(onDateSelected = { iclFechaInicio = it; showIclInicioPicker = false }, onDismiss = { showIclInicioPicker = false })
    if (showIclFinPicker) JuridicoDatePickerDialogKMP(onDateSelected = { iclFechaFin = it; showIclFinPicker = false }, onDismiss = { showIclFinPicker = false })
    if (showSalInicioPicker) JuridicoMonthYearPicker(initialDate = salFechaInicio, onDateSelected = { salFechaInicio = it; showSalInicioPicker = false }, onDismiss = { showSalInicioPicker = false })
    if (showSalFinPicker) JuridicoMonthYearPicker(initialDate = salFechaFin, onDateSelected = { salFechaFin = it; showSalFinPicker = false }, onDismiss = { showSalFinPicker = false })
    if (showCacInicioPicker) JuridicoMonthYearPicker(initialDate = cacFechaInicio, onDateSelected = { cacFechaInicio = it; showCacInicioPicker = false }, onDismiss = { showCacInicioPicker = false })
    if (showCacFinPicker) JuridicoMonthYearPicker(initialDate = cacFechaFin, onDateSelected = { cacFechaFin = it; showCacFinPicker = false }, onDismiss = { showCacFinPicker = false })
    if (showSmvmInicioPicker) JuridicoMonthYearPicker(initialDate = smvmFechaInicio, onDateSelected = { smvmFechaInicio = it; showSmvmInicioPicker = false }, onDismiss = { showSmvmInicioPicker = false })
    if (showSmvmFinPicker) JuridicoMonthYearPicker(initialDate = smvmFechaFin, onDateSelected = { smvmFechaFin = it; showSmvmFinPicker = false }, onDismiss = { showSmvmFinPicker = false })
    if (showJusFechaPicker) JuridicoDatePickerDialogKMP(onDateSelected = { jusFechaOrigen = it; showJusFechaPicker = false }, onDismiss = { showJusFechaPicker = false })
    if (showAddPagoDialog) DialogAgregarPago(onDismiss = { showAddPagoDialog = false }, onPagoAgregado = { smvmPagos = smvmPagos + it; showAddPagoDialog = false })
}

@Composable
fun AvisoProyeccionIPC(fechaFin: LocalDate, esProyectado: Boolean) {
    if (!esProyectado) return

    val hoy = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).date

    // Lógica de próxima publicación (Día 12)
    val fechaProximaPub = if (hoy.dayOfMonth <= 12) {
        "12/${hoy.monthNumber.toString().padStart(2, '0')}/${hoy.year}"
    } else {
        val proximoMes = hoy.plus(1, DateTimeUnit.MONTH)
        "12/${proximoMes.monthNumber.toString().padStart(2, '0')}/${proximoMes.year}"
    }

    Surface(
        color = Color(0xFFFFF3E0), // Naranja suave profesional
        shape = RoundedCornerShape(12.dp),
        border = BorderStroke(1.dp, Color(0xFFFFB74D)),
        modifier = Modifier.fillMaxWidth().padding(vertical = 12.dp)
    ) {
        Column(modifier = Modifier.padding(16.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(Icons.Default.Warning, null, tint = Color(0xFFE65100), modifier = Modifier.size(20.dp))
                Spacer(Modifier.width(8.dp))
                Text(
                    "Cálculo Proyectado",
                    style = MaterialTheme.typography.labelLarge,
                    fontWeight = FontWeight.Bold,
                    color = Color(0xFFE65100)
                )
            }
            Spacer(Modifier.height(8.dp))
            Text(
                text = "Este valor es aproximado ya que aún no se publicó el valor que corresponde para la fecha ${fechaFin.toTexto()}. El valor final se conocerá al publicarse el índice correspondiente.",
                style = MaterialTheme.typography.bodySmall,
                color = Color(0xFF5D4037),
                lineHeight = 16.sp
            )
            Spacer(Modifier.height(8.dp))
            Text(
                text = "Próxima publicación de este índice: $fechaProximaPub",
                style = MaterialTheme.typography.labelSmall,
                fontWeight = FontWeight.ExtraBold,
                color = Color(0xFFE65100)
            )
        }
    }
}

@Composable
fun AvisoIndiceNoPublicado(mesSolicitado: String?, mesUtilizado: String?) {
    if (mesSolicitado != null && mesUtilizado != null && mesSolicitado != mesUtilizado) {
        Surface(
            color = Color(0xFFFFF3E0),
            shape = RoundedCornerShape(12.dp),
            border = BorderStroke(1.dp, Color(0xFFFFB74D)),
            modifier = Modifier.fillMaxWidth().padding(top = 12.dp)
        ) {
            Row(
                modifier = Modifier.padding(12.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Icon(Icons.Default.Warning, null, tint = Color(0xFFE65100), modifier = Modifier.size(20.dp))
                Spacer(modifier = Modifier.width(12.dp))
                Text(
                    text = "Aviso: El índice de ${formatYearMonthSpanish(mesSolicitado)} aún no fue publicado. Se utilizó el último disponible (${formatYearMonthSpanish(mesUtilizado)}).",
                    style = MaterialTheme.typography.bodySmall,
                    color = Color(0xFFE65100),
                    lineHeight = 16.sp
                )
            }
        }
    }
}

@Composable
fun CardCAC(res: ResultadoComponenteCAC, titulo: String) {
    Card(modifier = Modifier.fillMaxWidth(), colors = CardDefaults.cardColors(containerColor = Color(0xFFFBE9E7))) {
        SelectionContainer {
            Column(modifier = Modifier.padding(12.dp)) {
                Text(titulo, fontWeight = FontWeight.Bold, fontSize = 12.sp, color = Color.Gray)
                Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                    Text(res.montoActualizado.toPesos(), fontSize = 20.sp, fontWeight = FontWeight.ExtraBold, color = Color(0xFFD84315))
                    Surface(color = Color(0xFFFFCCBC), shape = RoundedCornerShape(8.dp)) {
                        Text("+${res.variacionPorcentual.toPorcentajeDirecto()}", modifier = Modifier.padding(horizontal = 6.dp, vertical = 2.dp), fontSize = 11.sp, fontWeight = FontWeight.Bold, color = Color(0xFFBF360C))
                    }
                }
            }
        }
    }
}

@Composable
fun DialogAgregarPago(onDismiss: () -> Unit, onPagoAgregado: (PagoParcial) -> Unit) {
    var monto by remember { mutableStateOf("") }
    var fecha by remember { mutableStateOf(Clock.System.todayIn(TimeZone.currentSystemDefault())) }
    var obs by remember { mutableStateOf("") }
    var showDatePicker by remember { mutableStateOf(false) }

    AlertDialog(
        onDismissRequest = onDismiss,
        title = { Text("Registrar Pago Parcial") },
        text = {
            Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                OutlinedTextField(value = monto, onValueChange = { monto = it.filter { c -> c.isDigit() || c == '.' } }, label = { Text("Monto abonado") }, prefix = { Text("$ ") }, keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal), modifier = Modifier.fillMaxWidth())
                Box(modifier = Modifier.fillMaxWidth().clickable { showDatePicker = true }) {
                    OutlinedTextField(
                        value = fecha.toTexto(),
                        onValueChange = {},
                        label = { Text("Fecha de pago") },
                        readOnly = true,
                        modifier = Modifier.fillMaxWidth(),
                        enabled = false,
                        colors = OutlinedTextFieldDefaults.colors(
                            disabledTextColor = MaterialTheme.colorScheme.onSurface,
                            disabledBorderColor = MaterialTheme.colorScheme.outline,
                            disabledLabelColor = MaterialTheme.colorScheme.onSurfaceVariant,
                            disabledTrailingIconColor = MaterialTheme.colorScheme.onSurfaceVariant
                        ),
                        trailingIcon = { Icon(Icons.Default.CalendarToday, null) }
                    )
                }
                OutlinedTextField(value = obs, onValueChange = { obs = it }, label = { Text("Observaciones (opcional)") }, modifier = Modifier.fillMaxWidth())
            }
        },
        confirmButton = { Button(onClick = { if ((monto.toDoubleOrNull() ?: 0.0) > 0) onPagoAgregado(PagoParcial(fecha = fecha, monto = monto.toDoubleOrNull() ?: 0.0, observacion = obs)) }) { Text("Agregar") } },
        dismissButton = { TextButton(onClick = onDismiss) { Text("Cancelar") } }
    )
    if (showDatePicker) JuridicoDatePickerDialogKMP(onDateSelected = { fecha = it; showDatePicker = false }, onDismiss = { showDatePicker = false })
}

@Composable
fun SeccionExpandible(titulo: String, icono: ImageVector, color: Color, expandido: Boolean, onExpandChange: (Boolean) -> Unit, contenido: @Composable ColumnScope.() -> Unit) {
    Card(modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 6.dp).clickable { onExpandChange(!expandido) }, shape = RoundedCornerShape(16.dp)) {
        Column(modifier = Modifier.padding(16.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Box(modifier = Modifier.size(36.dp).background(color.copy(alpha = 0.2f), CircleShape), contentAlignment = Alignment.Center) {
                    Icon(icono, null, tint = color, modifier = Modifier.size(20.dp))
                }
                Spacer(modifier = Modifier.width(12.dp))
                Text(titulo, fontWeight = FontWeight.Bold, modifier = Modifier.weight(1f))
                Icon(if (expandido) Icons.Default.ExpandLess else Icons.Default.ExpandMore, null)
            }
            AnimatedVisibility(visible = expandido) {
                Column { Spacer(modifier = Modifier.height(16.dp)); contenido() }
            }
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun JuridicoMonthYearPicker(initialDate: LocalDate, onDateSelected: (LocalDate) -> Unit, onDismiss: () -> Unit) {
    var selectedMonth by remember { mutableStateOf(initialDate.monthNumber) }
    var selectedYear by remember { mutableStateOf(initialDate.year) }
    val isWeb = remember { getPlatform().name.contains("Web", ignoreCase = true) }
    val months = listOf("Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre")
    val years = (2018..2028).toList()

    if (isWeb) {
        Popup(onDismissRequest = onDismiss, properties = PopupProperties(focusable = true), alignment = Alignment.Center) {
            Box(modifier = Modifier.fillMaxSize().background(Color.Black.copy(alpha = 0.4f)).clickable { onDismiss() }, contentAlignment = Alignment.Center) {
                Surface(shape = RoundedCornerShape(28.dp), tonalElevation = 6.dp, modifier = Modifier.padding(16.dp).widthIn(max = 400.dp).clickable(enabled = false) {}) {
                    Column(modifier = Modifier.padding(24.dp), verticalArrangement = Arrangement.spacedBy(16.dp)) {
                        Text("Seleccionar Mes y Año", style = MaterialTheme.typography.titleLarge, fontWeight = FontWeight.Bold)
                        var monthExpanded by remember { mutableStateOf(false) }
                        ExposedDropdownMenuBox(expanded = monthExpanded, onExpandedChange = { monthExpanded = it }) {
                            OutlinedTextField(value = months[selectedMonth - 1], onValueChange = {}, readOnly = true, label = { Text("Mes") }, trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(monthExpanded) }, modifier = Modifier.fillMaxWidth().menuAnchor(MenuAnchorType.PrimaryNotEditable), shape = RoundedCornerShape(12.dp))
                            ExposedDropdownMenu(expanded = monthExpanded, onDismissRequest = { monthExpanded = false }) { months.forEachIndexed { i, n -> DropdownMenuItem(text = { Text(n) }, onClick = { selectedMonth = i + 1; monthExpanded = false }) } }
                        }
                        var yearExpanded by remember { mutableStateOf(false) }
                        ExposedDropdownMenuBox(expanded = yearExpanded, onExpandedChange = { yearExpanded = it }) {
                            OutlinedTextField(value = selectedYear.toString(), onValueChange = {}, readOnly = true, label = { Text("Año") }, trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(yearExpanded) }, modifier = Modifier.fillMaxWidth().menuAnchor(MenuAnchorType.PrimaryNotEditable), shape = RoundedCornerShape(12.dp))
                            ExposedDropdownMenu(expanded = yearExpanded, onDismissRequest = { yearExpanded = false }) { years.forEach { y -> DropdownMenuItem(text = { Text(y.toString()) }, onClick = { selectedYear = y; yearExpanded = false }) } }
                        }
                        Row(modifier = Modifier.fillMaxWidth().padding(top = 8.dp), horizontalArrangement = Arrangement.End) {
                            TextButton(onClick = onDismiss) { Text("Cancelar") }
                            Button(onClick = { onDateSelected(LocalDate(selectedYear, selectedMonth, 1)); onDismiss() }) { Text("Aceptar") }
                        }
                    }
                }
            }
        }
    } else {
        AlertDialog(onDismissRequest = onDismiss, title = { Text("Seleccionar Mes y Año") }, text = {
            Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                var monthExpanded by remember { mutableStateOf(false) }
                ExposedDropdownMenuBox(expanded = monthExpanded, onExpandedChange = { monthExpanded = it }) {
                    OutlinedTextField(value = months[selectedMonth - 1], onValueChange = {}, readOnly = true, label = { Text("Mes") }, trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(monthExpanded) }, modifier = Modifier.fillMaxWidth().menuAnchor(MenuAnchorType.PrimaryNotEditable), shape = RoundedCornerShape(12.dp))
                    ExposedDropdownMenu(expanded = monthExpanded, onDismissRequest = { monthExpanded = false }) { months.forEachIndexed { i, n -> DropdownMenuItem(text = { Text(n) }, onClick = { selectedMonth = i + 1; monthExpanded = false }) } }
                }
                var yearExpanded by remember { mutableStateOf(false) }
                ExposedDropdownMenuBox(expanded = yearExpanded, onExpandedChange = { yearExpanded = it }) {
                    OutlinedTextField(value = selectedYear.toString(), onValueChange = {}, readOnly = true, label = { Text("Año") }, trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(yearExpanded) }, modifier = Modifier.fillMaxWidth().menuAnchor(MenuAnchorType.PrimaryNotEditable), shape = RoundedCornerShape(12.dp))
                    ExposedDropdownMenu(expanded = yearExpanded, onDismissRequest = { yearExpanded = false }) { years.forEach { y -> DropdownMenuItem(text = { Text(y.toString()) }, onClick = { selectedYear = y; yearExpanded = false }) } }
                }
            }
        }, confirmButton = { Button(onClick = { onDateSelected(LocalDate(selectedYear, selectedMonth, 1)); onDismiss() }) { Text("Aceptar") } }, dismissButton = { TextButton(onClick = onDismiss) { Text("Cancelar") } })
    }
}

fun LocalDate.toYearMonth(): String = "${this.year}-${this.monthNumber.toString().padStart(2, '0')}"

fun LocalDate.toTextoSpanish(): String {
    val months = listOf("enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre")
    return "${months[this.monthNumber - 1]} de ${this.year}"
}

fun formatYearMonthSpanish(yearMonth: String?): String {
    if (yearMonth == null) return ""
    val parts = yearMonth.split("-")
    if (parts.size < 2) return yearMonth
    val month = parts[1].toIntOrNull() ?: return yearMonth
    val months = listOf("enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre")
    return if (month in 1..12) "${months[month - 1]} de ${parts[0]}" else yearMonth
}

fun formatIclDateSpanish(dateStr: String?): String {
    if (dateStr == null) return ""
    return try {
        val date = LocalDate.parse(dateStr)
        val months = listOf("enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre")
        "${date.dayOfMonth} de ${months[date.monthNumber - 1]} de ${date.year}"
    } catch (e: Exception) {
        dateStr
    }
}
